import axios from "axios";

export default {
    namespaced: true,
    state: {
        allQueues: [],
        allSpaces: [],
        allResouces: [],
        editedQueue: [],
        asociatedSpaces: [],
        standActions: [],
        showNavigation: true,
        showLeftMenu: false,
        LeftMenuAddNewSpace: false,
        showRightMenu: false,
        RightMenuAddNewQueue: false,
        RightMenuEditQueue: false,
        RightMenuAddNewStand: false,
        RightMenuStandDetail: false,
        objQueue: {},
        objQueueCont: {},
        objQueueContKiosk: {},
        project: "",
        tiquetsBySpace: [],
        Tiquet: [],
        TiquetFirst: [],
        TicketsBySpace: [],
        actualTicket: [],
        spaceSelected:[],
        TiquetAttended: [],
        TicketsInfoBySpace: [],
        TicketsInfoByQueueAndSpace: [],
        Lamp:[]

    },
    mutations: {
      setActualSpaceMutation(state,data){
        state.spaceSelected = data
      },
          cleanTicketFirst(state){
            state.TiquetFirst = []
          },

          setAllQueues(state, data) {
            
            let resouceNameArray = [];

            data.forEach(queueSpace => {
              
              state.allSpaces.forEach( queueSpaceId => {
    
                if (queueSpace.space == queueSpaceId.idSpace ){  
                  queueSpace.spaceName = queueSpaceId.name
                }  
      
              });

              if(queueSpace.resources != undefined && queueSpace.resources != ""){
                
                queueSpace.resources.forEach( resourcesByQueue => {

                  state.allResouces.forEach( allResoucesId => {

                    if (resourcesByQueue == allResoucesId.idResource){

                      resouceNameArray.push( allResoucesId.name);

                    }
                    
                  })
                  queueSpace.resouceName = resouceNameArray;
                });
              }
              resouceNameArray = []
              
              queueSpace.numberResources = queueSpace.resources.length;
            });

            state.allQueues = data
          },
          setAllSpaces(state, data) {            
            state.allSpaces = data
           },
           setAllResouces(state, data) {
             
             data.forEach( idSpace => {
              state.allSpaces.forEach( queueSpaceId => {
                if(idSpace.space == queueSpaceId.idSpace){ 
                  idSpace.spaceName = queueSpaceId.name;
                }
              })
             })             
            state.allResouces = data
           },
          getEditQueue(state, data ){

            let spacesNameEdit = [];
            data.resources.forEach( singleResource1 =>{

              state.allResouces.forEach( singleResouce2 => {
                
                if(singleResource1 == singleResouce2.idResource){

                  spacesNameEdit.push( singleResouce2.name);
          
                }
              })

            })
            data.spacesName = spacesNameEdit;
            
            state.editedQueue = data
          },
          showNavigation(state, bool) {
            state.showNavigation = bool;
          },
          openLeftMenuMutation(state) {            
            state.showLeftMenu = true;
          },
          closeLeftMenuMutation(state) {            
            state.showLeftMenu = false
            state.LeftMenuAddNewSpace = true;
          },
          LeftMenuTrueNewSpace(state) {
            state.LeftMenuAddNewSpace = true;
          },
          openRightMenuMutation(state) {            
            state.showRightMenu = true;
          },
          
          closeRightMenuMutation(state) {            
            state.showRightMenu = false
            state.RightMenuAddNewQueue = true;
          },
          
          closeRightMenuMutation2(state) {            
            state.showRightMenu = false
            state.RightMenuEditQueue = true;
          },
          
          closeRightMenuMutation3(state) {            
            state.showRightMenu = false
            state.RightMenuAddNewStand = true;
          },

          rightMenuTrueNewDeviceTable(state) {
            state.RightMenuAddNewQueue = true;
            state.RightMenuEditQueue = false;
            state.RightMenuAddNewStand = false;
            state.RightMenuStandDetail = false;

          },
          rightMenuTrueNewDeviceTable2(state, data) { 
            state.editedQueue = data           
            state.RightMenuAddNewQueue = false;
            state.RightMenuEditQueue = true;
            state.RightMenuAddNewStand = false;
            state.RightMenuStandDetail = false;

          },
          rightMenuTrueNewDeviceTable3(state) { 
            state.RightMenuAddNewQueue = false; 
            state.RightMenuEditQueue = false;
            state.RightMenuAddNewStand = true;
            state.RightMenuStandDetail = false;

          },
          rightMenuTrueNewDeviceTable4(state) {
            state.RightMenuAddNewQueue = false;
            state.RightMenuEditQueue = false; 
            state.RightMenuAddNewStand = false;
            state.RightMenuStandDetail = true;
          },
          closeRightMenuMutation4(state) {            
            state.showRightMenu = false
            state.RightMenuStandDetail = true;
          },
          storeAssociatedSpaces(state, data){
            state.asociatedSpaces = data
          },
          cleanValue(state){
            state.objQueue = {};
          },
          getTicketBySpaceState(state, data){
            state.tiquetsBySpace = data
          },
          spaceActions(state, data){
            state.standActions = data
          },
          getTickets(state, data){
            state.Tiquet = data
          },
          getTicketsFirst(state, data){
            if(data.lamp != null ){
              state.Lamp = data.lamp
            }else{
              state.Lamp = []
            }

            let numTiquets = 0;
            data.queues.forEach(element => {
              if(element.tickets == null){
                element.pending = 0
              }else{
                element.tickets.forEach(ticket => {
                  if(ticket.stationDestiny.id == 0){
                    numTiquets ++;
                  }
                });
                 element.pending = numTiquets;
              }
              numTiquets = 0;
            });
            state.TiquetFirst = data.queues
          },
          getTicketsAttendedStore(state, data){
            state.TiquetAttended = data
          },
          getTicketsInfoBySpaceStore(state, data){
            if(data.length > 0){
            data[0].meanDuration = Math.round(data[0].meanDuration)/1000
            }
            state.TicketsInfoBySpace = data
          },
          getTicketsInfoByQueueAndSpaceStore(state, data){
            state.TicketsInfoByQueueAndSpace = data
          },
          getTicketsBySpaceState(state, data){

            data.forEach( idResource => {
  
              state.allResouces.forEach( queueResourceId => {

                if(idResource.resources == queueResourceId.idResource){ 
                  idResource.spaceName = queueResourceId.name;
                }
                
              })
             }) 
            //  console.log(data);
             
            state.TicketsBySpace = data
          },
          ActualTicket(state, data){
            state.actualTicket = data
          },

    },

    actions: {

        async getAllQueues({ commit }, idProject) {
            
            try {
              
              let response = await axios.get(`/Aqueues/project/${idProject}`);              
              let result = response.data;
              // console.log( result);

              commit("setAllQueues", result);
            
            //   return result;
            } catch (err) {
              console.log(err);
              // commit("changeAlertModal", err.response.data.result[0]);
            }
        }, 
        async getAllSpaces({ commit }, idProject) {
            
          try {
            let response = await axios.get(`/Aspaces/project/${idProject}`);              
            let result = response.data;
            commit("setAllSpaces", result);
          
          //   return result;
          } catch (err) {
            console.log(err);
            // commit("changeAlertModal", err.response.data.result[0]);
          }
      }, 
      async getAllResouces({ commit },idProject) {
            
        try {
          let response = await axios.get(`/Aresources/project/${idProject}`);              
          let result = response.data;
          
          commit("setAllResouces", result);
        
        //   return result;
        } catch (err) {
          console.log(err);
          // commit("changeAlertModal", err.response.data.result[0]);
        }
    }, 
    async changeOperative({ commit, dispatch },idResource) {
            
      try {
       // /Aresources/:idResource
        let response = await axios.post(`/Aresources/${idResource}`);              
        let result = response.data;
        
        dispatch("getAllResouces", result.idProject);
      
      //   return result;
      } catch (err) {
        console.log(err);
        // commit("changeAlertModal", err.response.data.result[0]);
      }
    }, 
    async addQueueStore({ commit }, data ) {
      try {
                       
          let response = await axios.post(
            "/Aqueues", data
          );

          let result = response.data;
          // console.log(result);
          commit("cleanValue");
          // return result;
        } catch (err) {
          console.log(err);
          // commit("changeAlertModal", err.response.data.result[0]);
        }
      
  },
        async editQueueStore({ commit }, campaignSelected) {
            try {                                
                let response = await axios.get(
                  `/Aqueues/${campaignSelected}`
                );

                let result = response.data;
                // console.log(result);
                commit("getEditQueue", result);
                return result;
              } catch (err) {
                console.log(err);
                // commit("changeAlertModal", err.response.data.result[0]);
              }
            
        },
        async editedQueueStore({ commit }, campaignSelected) {
          try { 
          
             let response = await axios.put(
                `/Aqueues/${campaignSelected.idQueue}`, campaignSelected
              );

              let result = response.data;
              // console.log(result);
              // commit("getEditQueue", result);
              // return result;
            } catch (err) {
              console.log(err);
              // commit("changeAlertModal", err.response.data.result[0]);
            }
          
      },
        async deleteOneQueueStore({ commit },idQueue) {
          try {  
            // console.log(idQueue.idQueue);
                                          
              let response = await axios.delete(
                `/Aqueues/${idQueue.idQueue}`
              );

              let result = response.data;
              // console.log(result);
              // commit("getEditQueue", result);
              // return result;
            } catch (err) {
              console.log(err);
              // commit("changeAlertModal", err.response.data.result[0]);
            }
          
      },
      async deleteMultipleQueues({ commit }, data) {
        try {  
             
            let response = await axios.delete(
              "/Aqueues" ,{ data: {
                ids: data
              }}
            );

            let result = response.data;
            // console.log(result);
            // commit("deleteDialogFalse");
            // return result;
          } catch (err) {
            console.log(err);
            // commit("changeAlertModal", err.response.data.result[0]);
          }
        
    },
      
      async getAsociatedResourcesStore({ commit }, idSpace) {
        try {                                          
            let response = await axios.get(
              `/Aspaces/resources/${idSpace}`
            );

            let result = response.data;
            // console.log(result);
            commit("storeAssociatedSpaces", result);
            // return result;
          } catch (err) {
            console.log(err);
            // commit("changeAlertModal", err.response.data.result[0]);
          }
        
    },
    
  async createTicketStore({ commit }, ids ) {
    try { 
         let idQueue= ids[0]
         let  idResource = ids[1]                                     
        let response = await axios.get(
          `/Aqueues/tickets/action/create/${idQueue}/${idResource}`
        );

        let result = response.data;
        // console.log(result);
        commit("ActualTicket", result);
        // return result;
      } catch (err) {
        console.log(err);
        // commit("changeAlertModal", err.response.data.result[0]);
      }
    
  },

  async restartQueueStore({ commit }, ids ) {
    try { 
        let idQueue= ids[0]
        let  idResource = ids[1]                                     
        let response = await axios.get(
          `/Aqueues/tickets/action/reboot/${idQueue}/${idResource}`
        );
  
        let result = response.data;
        // console.log(result);
        commit("ActualTicket", result);
        // return result;
      } catch (err) {
        console.log(err);
        // commit("changeAlertModal", err.response.data.result[0]);
      }
    
  },
  async assignTicketStore({ commit }, ids ) {
    try { 
        let idQueue= ids[0]
        let  idResource = ids[1]                                     
        let response = await axios.get(
          `/Aqueues/tickets/action/assign/${idQueue}/${idResource}`
        );

        let result = response.data;
        // console.log(result);
        commit("ActualTicket", result);
        // return result;
      } catch (err) {
        console.log(err);
        // commit("changeAlertModal", err.response.data.result[0]);
      }
    
},
async assignTicketStore2({ commit }, obj ) {
  try { 
                                  
      let response = await axios.post(
        `Aqueues/resources/tickets/action/`, obj
      );

      let result = response.data;
      // console.log(result);
      commit("ActualTicket", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async closeTicketStore({ commit }, ids ) {
  try { 
      let idQueue= ids[0]
      let  idResource = ids[1]                                     
      let response = await axios.get(
        `/Aqueues/tickets/action/close/${idQueue}/${idResource}`
      );

      let result = response.data;
      // console.log(result);
      commit("getTickets", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async closeNextStore({ commit }, ids ) {
  try {  
      let idQueue= ids[0]
      let  idResource = ids[1]                                     
      let response = await axios.get(
        `/Aqueues/tickets/action/next/${idQueue}/${idResource}`
      );

      let result = response.data;
      // console.log(result);
      // commit("getTickets", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async closeNextStore2({ commit }, obj ) {
try {  
          
    let response = await axios.post(
      `Aqueues/resources/tickets/action/`, obj
    );

    let result = response.data;
    // console.log(result);
    // commit("getTickets", result);
    // return result;
  } catch (err) {
    console.log(err);
    // commit("changeAlertModal", err.response.data.result[0]);
  }

},
async cancelnextStore({ commit }, ids ) {
  try {  
      let idQueue= ids[0]
      let  idResource = ids[1]                                     
      let response = await axios.get(
        `/Aqueues/tickets/action/cancelnext/${idQueue}/${idResource}`
      );

      let result = response.data;
      // console.log(result);
      // commit("getTickets", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async cancelnextStore2({ commit }, obj ) {
try {  
                                
    let response = await axios.post(
      `Aqueues/resources/tickets/action/`, obj
    );

    let result = response.data;
    // console.log(result);
    // commit("getTickets", result);
    // return result;
  } catch (err) {
    console.log(err);
    // commit("changeAlertModal", err.response.data.result[0]);
  }

},
async deleteTicketStore({ commit }, ids ) {
try { 
    let idQueue= ids[0]
    let  idResource = ids[1]                                     
    let response = await axios.get(
      `/Aqueues/tickets/action/delete/${idQueue}/${idResource}`
    );

    let result = response.data;
    // console.log(result);
    commit("ActualTicket", result);
    // return result;
  } catch (err) {
    console.log(err);
    // commit("changeAlertModal", err.response.data.result[0]);
  }

},
async assignTicketStoreLeft({ commit }, ids ) {
try { 
    let idQueue= ids[0]
    let  idResource = ids[1]                                     
    let response = await axios.get(
      `/Aqueues/tickets/action/assign/${idQueue}/${idResource}`
    );

    let result = response.data;
    // console.log(result);
    commit("ActualTicket", result);
    // return result;
  } catch (err) {
    console.log(err);
    // commit("changeAlertModal", err.response.data.result[0]);
  }

},
async getTicketAttended({ commit }, id ) {
  try { 
    
      let id2 = id.toString()
      let last_id= { idResource: id2 }
      let response = await axios.post(
        `Aanalytics/queues/resources/tickests/now`, last_id
      );

      let result = response.data;

      commit("getTicketsAttendedStore", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},  
async getTicketStore({ commit }, id ) {
  try { 
                          
      let response = await axios.get(
        `/Aqueues/tickets/resocurce/${id}`
      );

      let result = response.data;
      // console.log(result);
      commit("getTicketsFirst", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},  
async getTicketBySpaceStore({ commit }, idSpace) {
  try {                                          
      // let response = await axios.get(
      //   `/Aspaces/resources/${idSpace.space}`
      // );

      // let result = response.data;
      // console.log(result);
      commit("spaceActions", idSpace);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async getTicketBySpace({ commit }, id ) {
  try { 
                          
      let response = await axios.get(
        `/Aqueues/queues/tickets/space/${id}`
      );

      let result = response.data;
      // console.log(result);
      commit("getTicketsBySpaceState", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},  
async sendHtmlSpaceStore({ commit }, data ) {
  let form_data = new FormData();
  let dataToSend = data[0]

  for (let key in dataToSend) {
    form_data.append(key, dataToSend[key]);
  }

  for (var pair of form_data.entries()) {
    console.log(pair[0] + ", " + pair[1]);
  }

  try {
      // console.log("entro");
      // console.log(data);
      let response = await axios.post(
        `/Aspaces/queues/post/content/admira/complet/${data[2]}/${data[1]}`, form_data
      );

      let result = response.data;
      // console.log(result);
      // commit("cleanValue");
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},


async sendHtmlSpaceKioskStore({ commit }, data ) {
  let form_data = new FormData();
  let dataToSend = data[0]

  for (let key in dataToSend) {
    form_data.append(key, dataToSend[key]);
  }

  for (var pair of form_data.entries()) {
    console.log(pair[0] + ", " + pair[1]);
  }

  try {
      // console.log("entro");
      // console.log(data);
      let response = await axios.post(
        `Aspaces/queues/kiosk/post/content/admira/complet/${data[2]}/${data[1]}`, form_data
      );

      let result = response.data;
      // console.log(result);
      // commit("cleanValue");
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
},
async getTicketsInfoByQueueAndSpace({ commit }, id ) {
  try { 
    
      let id2 = id.toString()
      let last_id= { "idSpace": id2 }
      let response = await axios.post(
        `Aanalytics/spaces/queues/tickests/now`, last_id
      );

      let result = response.data;
      //   console.log(result);
        
      commit("getTicketsInfoByQueueAndSpaceStore", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
}, 
async getTicketsInfoBySpace({ commit }, id ) {
  try { 
    
      let id2 = id.toString()
      var date = new Date();
      var startTimestamp= date.setHours(0,0,0,0);
      var endTimestamp= date.setHours(23,59,59,59);
      // var startTimestampString = startTimestamp.toString();
      // var endTimestampString = endTimestamp.toString();

      let last_id= { "idSpace" : id2,
      "start":startTimestamp,
      "end":endTimestamp}

      let response = await axios.post(
        `Aanalytics/space/tickests/range`, last_id
      );

      let result = response.data;
      //   console.log(result);
        
      commit("getTicketsInfoBySpaceStore", result);
      // return result;
    } catch (err) {
      console.log(err);
      // commit("changeAlertModal", err.response.data.result[0]);
    }
  
}, 
      rightMenuTrueNewDeviceTableStore({ commit }) {
        commit("rightMenuTrueNewDeviceTable");        
      },
      rightMenuTrueNewDeviceTableStore2({ commit }, data) {        
        commit("rightMenuTrueNewDeviceTable2", data);        
      },
      rightMenuTrueNewDeviceTableStore3({ commit }) {        
        commit("rightMenuTrueNewDeviceTable3");        
      },
      rightMenuTrueNewDeviceTableStore4({ commit }) {        
        commit("rightMenuTrueNewDeviceTable4");        
      },
    }
  };


// WEBPACK FOOTER //
// ./src/store/queues.js